import { render } from "./pointsRecord.vue?vue&type=template&id=c7c29e76&scoped=true"
import script from "./pointsRecord.vue?vue&type=script&lang=js"
export * from "./pointsRecord.vue?vue&type=script&lang=js"

import "./pointsRecord.vue?vue&type=style&index=0&id=c7c29e76&lang=scss&scoped=true"

import exportComponent from "/home/hsf/.jenkins/workspace/mmm-overseas-prod-hongkong/rith-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7c29e76"]])

export default __exports__